import React, { useState } from 'react'
import {
  Typography,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { isEmpty, has, unset } from 'lodash'

import {
  publishChangeJoinability,
  publishClickedCancelJoinability,
} from '../../../util/events/teamsEventPublishers'
import TitleCard from '../common/TitleCard'
import CardWrapper from './CardWrapper'
import CardActionButton from './CardActionButton'

function TeamVisibility({ team, onChange, pendingChanges }) {
  return (
    <Box mt={2}>
      <Typography color="textSecondary" variant="overline">
        Team Visiblity
      </Typography>
      <Typography variant="subtitle2">Choose how people can join your team:</Typography>
      <FormControl>
        <RadioGroup
          arial-label="public joinable"
          name="privacy"
          value={pendingChanges.privacy || team.privacy}
          onChange={onChange}
        >
          <FormControlLabel
            value="OPEN_TO_DOMAIN"
            control={<Radio color="primary" />}
            label={`Allow invitiations AND anyone with an "@${team.emailDomain}" email to join`}
          />
          <FormControlLabel
            value="INVITE_ONLY"
            control={<Radio color="primary" />}
            label="Only allow people to join if they are invited"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default function CardAccountSettings({ team, loading, onSubmit }) {
  const [pendingChanges, setPendingChanges] = useState({})

  const onSettingChange = event => {
    const { name, value } = event.target

    //remove from pending changes if same as saved value
    if (has(pendingChanges, name) && team[name] === value) {
      const copiedChanges = JSON.parse(JSON.stringify(pendingChanges))
      unset(copiedChanges, name)
      setPendingChanges(copiedChanges)
    } else {
      setPendingChanges({
        ...pendingChanges,
        [name]: value,
      })

      if (name === 'privacy') publishChangeJoinability(value)
    }
  }

  const onFinalSubmit = () => {
    onSubmit(pendingChanges)
    setPendingChanges({})
  }

  const handleClickCancel = () => {
    publishClickedCancelJoinability()
    setPendingChanges({})
  }

  if (loading) {
    return (
      <CardWrapper>
        <TitleCard>Settings</TitleCard>
        <Skeleton height={150} />
      </CardWrapper>
    )
  }

  return (
    <CardWrapper>
      {!isEmpty(pendingChanges) && <CardActionButton name="Cancel" onClick={handleClickCancel} />}

      <TitleCard>Settings</TitleCard>
      <TeamVisibility team={team} pendingChanges={pendingChanges} onChange={onSettingChange} />

      {!isEmpty(pendingChanges) && (
        <Box height={35}>
          <CardActionButton
            name="Submit Changes"
            onClick={onFinalSubmit}
            variant="outlined"
            fullHeight
          />
        </Box>
      )}
    </CardWrapper>
  )
}
